module.exports = __webpack_public_path__ + "img/03.74bed402.jpg";